import { useCallback } from 'react';
import { SaveClientFlags, SetupOrgOnboardingSteps } from '@sdk/authentication/types';
import { AuthUserType } from '@sdk/authentication/types/AuthUserType';

type FlagsProps = {
  user: AuthUserType;
  saveClientFlags: SaveClientFlags;
};

export const useOnboardingFlags = ({ user, saveClientFlags }: FlagsProps) => {
  const { onboarding } = user.settings.clientFlags;

  const updateOnboardingFlags = useCallback(
    (completedStep: SetupOrgOnboardingSteps, activeStep: SetupOrgOnboardingSteps) => {
      const completedDiff = onboarding.finishedSteps.includes(completedStep) ? [] : [completedStep];

      saveClientFlags({
        flags: {
          onboarding: {
            ...onboarding,
            finishedSteps: [...onboarding.finishedSteps, ...completedDiff],
            activeStep,
          },
        },
      });
    },
    [saveClientFlags, onboarding]
  );

  return { onboardingFlags: onboarding, updateOnboardingFlags };
};
